import { EditorState, inboxEditorType, InboxFilters } from 'components/ui/organisms/CentralInbox/CentralInbox.types';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { InboxStore } from './inbox.store.types';

export const useInboxStore = create<InboxStore>()(
  persist(
    (set) => ({
      editorRefs: { subject: null, body: null },
      setEditorRefs: (refs) => set(() => ({ editorRefs: refs })),

      isTeamViewEnabled: false,
      toggleTeamView: () => set((state) => ({ isTeamViewEnabled: !state.isTeamViewEnabled })),

      selectedFilter: InboxFilters.ALL,
      setSelectedFilter: (filter: InboxFilters) => set(() => ({ selectedFilter: filter })),

      isSidebarOpened: true,
      setIsSidebarOpened: (value) => set(() => ({ isSidebarOpened: value })),

      isCandidateDetailsOpened: false,
      setIsCandidateDetailsOpened: (value) => set(() => ({ isCandidateDetailsOpened: value })),

      selectedChannel: inboxEditorType.Note,
      setSelectedChannel: (value) => set(() => ({ selectedChannel: value })),

      editorState: EditorState.Default,
      setEditorState: (value) => set(() => ({ editorState: value })),

      onConfirmDialogCb: null,
      setOnConfirmDialogCb: (cb) => set(() => ({ onConfirmDialogCb: cb })),
    }),
    {
      name: 'teamView',
      partialize: (state) => ({ isTeamViewEnabled: state.isTeamViewEnabled }),
    },
  ),
);
